import { LivePage } from './pages/Live';
import MainMenu from './components/MainMenu';
import { PageHeader } from './components/PageHeader';
import TapeChart from "./pages/TapeChart";
import YieldPopup from "./components/YieldPopup";
import BankDeposits from "./pages/BankDeposit";
import Reports from "./components/Reports";
import BankDepositsReport from "./components/Reports/BankDeposit";
import AnalyticsUserMapping from "./pages/AnalyticsUserMapping";
import CustomerChannelMapping from "./components/CustomerChannelMapping";
import RestrictionsPopup from './components/RestrictionsPopup';
import { RestrictionDetailsPage } from './features/restriction-details';
import PriceUpdatePopup from './components/PriceUpdatePopup';
import PyramidReportsTabs from "./pages/PyramidReportsTabs";
import CumulativeDetailedIncomeReport from "./components/Reports/CumulativeDetailedIncomeReport";
import GroupReservation from "./pages/GroupReservation";
import ApartmentOwnersPortal from "./pages/ApartmentOwnersPortal";
import ApartmentsOwnersPortalMenu from "./pages/ApartmentOwnersPortal/menu";
import AddonsByReservationReport from "./components/Reports/AddonsByReservation";
import AddonsCommissionsReport from "./components/Reports/AddonsCommissions";
import ColorPicker from "./components/shared/ColorPicker";
import ImportExcelPage from "./pages/ImportExcel";
import ReservationPage from "./pages/Reservation";
import FolioSideTabs from "./components/FolioSideTabs";
import { AddCardPopup, MakePaymentPopup } from "./components/Payment";
import ProformaPopup from "./pages/Folio/proforma";
import DetailedCashReport from "./components/Reports/DetailedCash";
import { HomePage } from "./pages/Home";
import ReceiptPopup from "./components/ReceiptPopup";
import AddPaymentTransactionPopup from "./components/AddPaymentTransactionPopup";
import SaleGuideCommentsPopup from "./components/SaleGuideCommentsPopup";
import CustomerDropDown from "./components/shared/CustomerDropDown";
import { DashBoard } from "./pages/DashBoard";
import DefaultHomePageDropDown from "./components/shared/DefaultHomePageDropDown";
import CheckTaxExemptionPopup from "./components/CheckTaxExemptionPopup";
import OccupancyForecastReport from "./components/Reports/DaysForecast/OccupancyForecast";
import AddonsForecastReport from "./components/Reports/DaysForecast/AddonsForecast";
import GuestsForecastReport from "./components/Reports/DaysForecast/GuestsForecast";
import RoomsForecastReport from "./components/Reports/DaysForecast/RoomsForecast";
import CancelReservationsReport from "./components/Reports/CancelReservations";
import ReservationSearch from "./pages/Reservation/search";
import ReservationsByCheckInDateForHotelOwnerReport from "./components/Reports/Reservations/ReservationsByCheckInDateForHotelOwner";
import HousekeepingReport from "./components/Reports/HouseKeeping";
import ReservationPolicy from "./pages/ReservationPolicy";
import GroupReservationsByCheckInDateReport from "./components/Reports/Groups/GroupReservationsByCheckInDate";
import { EmailSettings } from "./pages/EmailSettings";
import Tags from "./pages/Tags";
import { GuestReport } from "./components/Reports/Guest";
import InvoicesReceiptsReport from "./components/Reports/InvoicesReceipts";
import { RMSRulesPage } from './pages/RMSRules'
import MultipleCommissionPopup from "./components/CustomerCommission";
import { ExpensesManagementPage } from './pages/Expenses'
import { ApartmentOwnerReport } from "./components/Reports/ApartmentOwner";
import { CustomerIncomeReport } from "./components/Reports/CustomerIncome";
import { DocumentSeriesPage } from './pages/DocumentSeries'
import AccountingSystemReport from "./components/Reports/AccountingSystem"
import FolioPendingPopup from './components/FolioPendingPopup'
import { HotelCurrencyPage } from './pages/HotelCurrency'
import { LoginPage } from './pages/Login'
import ShortReservationPopup from './components/ShortReservationPopup'
import { AccountingSystemMappingPage } from './pages/AccountingSystemMappingPage';
import ReceptionAnywhere from './pages/ReceptionAnywhere';
import ArrivalsAndGuestInHouseSearch from "./components/ArrivalsAndGIHSearch";
import SendMailPopup from './components/SendMailPopup'
import Allocation from './pages/AllocationAndStrategy/Allocation'
import SearchPriceLists from './pages/PriceList/SearchPriceLists'
import Strategy from './pages/AllocationAndStrategy/Strategy'
import { PriceListSettings } from "./pages/PriceList";
import PricingTemplates from './pages/PricingTemplates'
import DiscountPopup from "./components/DiscountPopup"
import { ExternalEntityMapping } from "./pages/ExternalEntityMapping"
import FolioSearch from './pages/Folio/search'
import TrialBalanceReport from './components/Reports/TrialBalance'
import ProductSearch from './pages/ProductSearch'
import { Content } from "./pages/PriceList/Content";
import Promotion from "./pages/Promotion";
import { OverBookingPage } from "./pages/OverBooking";
import CustomerGroups from './pages/CustomerGroups';
import { MonthlyView } from './pages/MonthlyView'
import { ReportList } from './pages/ReportBuilder'
import RoomTypeFinalPricesReport from './components/Reports/RoomTypeFinalPrices'
import FinalPricesByCombinationReport from './components/Reports/FinalPricesByCombination'
import AddonsFinalPricesReport from './components/Reports/AddonsFinalPrices'
import RoomTypeAddonPopup from "./pages/PriceList/Pricing/RoomTypeAddonPopup";
import AddRoomClassPopup from './pages/RoomType/popups/RoomClass/AddRoomClassPopup'
import { LRVPage } from "./pages/LRVPage";
import KeyMakerPopup from "./components/KeyMakerPopup";
import Calendar from './pages/Calendar';
import { DefaultReservationValues } from './pages/DefaultReservationValues/index.jsx';
import ExtraAddonsPopup from './components/ExtraAddonsPopup/index.jsx';
import IsraelTaxAuthority from './pages/IsraelTaxAuthority';
import ReservationPolicyPopup from './components/ReservationPolicyPopup';
import CancelReservationPopup from './components/CancelReservationPopup';
import ReservationPolicyUpdateConfirmationPopup from "./components/ReservationPolicyUpdateConfirmationPopup/index.jsx";
import { HotelAddonInventoryPage } from './pages/HotelAddonInventoryPage/index.jsx';
import HotelAddonsTapeChart from './pages/HotelAddonsTapeChart/index.jsx';
import AvailabilityPage from './pages/Availability/index.jsx';
import RefundPopup from './components/RefundPopup/index.jsx';
import ChangePasswordPage from './pages/ChangePassword';
import LoginTwoFactorPage from './pages/Login/TwoFactor.jsx';
import RoomPlannedMaintenance from './pages/RoomPlannedMaintenance/index.jsx';
import ReasonsSettingPage from './pages/ReasonsSetting/index.jsx';
import StatisticSourcesSettings from './pages/RateSettings/StatisticSourcesSettings';
import PriceGroupsSettings from './pages/RateSettings/PriceGroupsSettings';
import ClassificationCategoriesSettings from './pages/RateSettings/ClassificationCategoriesSettings';
import PendingFoliosReport from './components/Reports/PendingFolios/index.jsx';
import RefusedInvoiceTreatmentPopup from './components/RefusedInvoiceTreatmentPopup';
import BulkUpdateHotelDateParameterPopup from './components/BulkUpdateHotelDateParameterPopup';


export const components = {
    ReportList,
    OverBookingPage,
    Content,
    ProductSearch,
    LivePage,
    DiscountPopup,
    PriceListSettings,
    ReceiptPopup,
    TapeChart,
    YieldPopup,
    BankDepositsReport,
    BankDeposits,
    MainMenu,
    KeyMakerPopup,
    Reports,
    AnalyticsUserMapping,
    CustomerChannelMapping,
    RestrictionsPopup,
    PriceUpdatePopup,
    PyramidReportsTabs,
    CumulativeDetailedIncomeReport,
    GroupReservation,
    ApartmentOwnersPortal,
    ApartmentsOwnersPortalMenu,
    AddonsByReservationReport,
    AddonsCommissionsReport,
    ColorPicker,
    ImportExcelPage,
    ReservationPage,
    PageHeader,
    FolioSideTabs,
    AddCardPopup,
    MakePaymentPopup,
    ProformaPopup,
    DetailedCashReport,
    OccupancyForecastReport,
    AddonsForecastReport,
    GuestsForecastReport,
    RoomsForecastReport,
    HomePage,
    AddPaymentTransactionPopup,
    SaleGuideCommentsPopup,
    CustomerDropDown,
    DashBoard,
    DefaultHomePageDropDown,
    CheckTaxExemptionPopup,
    ReservationSearch,
    CancelReservationsReport,
    ReservationsByCheckInDateForHotelOwnerReport,
    HousekeepingReport,
    ReservationPolicy,
    GroupReservationsByCheckInDateReport,
    EmailSettings,
    GuestReport,
    Tags,
    InvoicesReceiptsReport,
    RMSRulesPage,
    MultipleCommissionPopup,
    ExpensesManagementPage,
    AccountingSystemReport,
    ApartmentOwnerReport,
    CustomerIncomeReport,
    FolioPendingPopup,
    HotelCurrencyPage,
    LoginPage,
    ShortReservationPopup,
    DocumentSeriesPage,
    AccountingSystemMappingPage,
    ReceptionAnywhere,
    Allocation,
    SearchPriceLists,
    Strategy,
    ArrivalsAndGuestInHouseSearch,
    SendMailPopup,
    PricingTemplates,
    ExternalEntityMapping,
    FolioSearch,
    TrialBalanceReport,
    Promotion,
    CustomerGroups,
    MonthlyView,
    RoomTypeFinalPricesReport,
    FinalPricesByCombinationReport,
    AddonsFinalPricesReport,
    RoomTypeAddonPopup,
    AddRoomClassPopup,
    LRVPage,
    Calendar,
    DefaultReservationValues,
    ExtraAddonsPopup,
    IsraelTaxAuthority,
    ReservationPolicyPopup,
    CancelReservationPopup  ,
    ReservationPolicyUpdateConfirmationPopup,
    HotelAddonInventoryPage,
    HotelAddonsTapeChart,
    AvailabilityPage,
    RefundPopup,
    ChangePasswordPage,
    LoginTwoFactorPage,
    ReasonsSettingPage,
    RoomPlannedMaintenance,
    StatisticSourcesSettings,
    PriceGroupsSettings,
    ClassificationCategoriesSettings,
    BulkUpdateHotelDateParameterPopup,
    PendingFoliosReport,
    RefusedInvoiceTreatmentPopup,
    RestrictionDetailsPage,
};
